import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, ref, onMounted, onUnmounted } from '../../../../../adapter-vue';
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
var ReadState;
(function (ReadState) {
  ReadState[ReadState["Read"] = 0] = "Read";
  ReadState[ReadState["Unread"] = 1] = "Unread";
  ReadState[ReadState["AllRead"] = 2] = "AllRead";
  ReadState[ReadState["NotShow"] = 3] = "NotShow";
  ReadState[ReadState["PartiallyRead"] = 4] = "PartiallyRead";
})(ReadState || (ReadState = {}));
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: {
      default: () => ({})
    }
  },
  emits: ["openReadUserPanel"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var emits = __emit;
    var props = __props;
    var TYPES = TUIChatEngine.TYPES;
    // 用户级别的已读回执开关 优先级最高
    var isDisplayMessageReadReceipt = ref(TUIStore.getData(StoreName.USER, 'displayMessageReadReceipt'));
    onMounted(() => {
      TUIStore.watch(StoreName.USER, {
        displayMessageReadReceipt: onDisplayMessageReadReceiptUpdate
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.USER, {
        displayMessageReadReceipt: onDisplayMessageReadReceiptUpdate
      });
    });
    var isShowReadStatus = computed(() => {
      if (!isDisplayMessageReadReceipt.value) {
        // 用户级已读回执开关关闭 不展示已读状态
        return false;
      }
      var {
        ID,
        type,
        flow,
        status,
        hasRiskContent,
        conversationID,
        conversationType,
        needReadReceipt = false
      } = props.message;
      // 异步消息打击 消息已发出判断是否存在风险内容
      if (hasRiskContent) {
        return false;
      }
      var {
        groupProfile
      } = TUIStore.getConversationModel(conversationID) || {};
      // 直播群以及社群不展示已读状态
      if ((groupProfile === null || groupProfile === void 0 ? void 0 : groupProfile.type) === TYPES.GRP_AVCHATROOM || (groupProfile === null || groupProfile === void 0 ? void 0 : groupProfile.type) === TYPES.GRP_COMMUNITY) {
        return false;
      }
      if (type === TYPES.MSG_CUSTOM) {
        var message = TUIStore.getMessageModel(ID);
        // 如果是信令消息 不展示阅读状态
        if ((message === null || message === void 0 ? void 0 : message.getSignalingInfo()) !== null) {
          return false;
        }
      }
      // 未成功消息 接收消息 不展示阅读状态
      if (flow !== 'out' || status !== 'success') {
        return false;
      }
      if (conversationType === 'GROUP') {
        return needReadReceipt;
      } else if (conversationType === 'C2C') {
        return true;
      }
      return false;
    });
    var readState = computed(() => {
      var {
        conversationType,
        needReadReceipt = false,
        isPeerRead = false
      } = props.message;
      var {
        readCount = 0,
        unreadCount = 0,
        isPeerRead: isReceiptPeerRead = false
      } = props.message.readReceiptInfo;
      if (conversationType === 'C2C') {
        if (needReadReceipt) {
          return isReceiptPeerRead ? ReadState.Read : ReadState.Unread;
        } else {
          return isPeerRead ? ReadState.Read : ReadState.Unread;
        }
      } else if (conversationType === 'GROUP') {
        if (needReadReceipt) {
          if (readCount === 0) {
            return ReadState.Unread;
          } else if (unreadCount === 0) {
            return ReadState.AllRead;
          } else {
            return ReadState.PartiallyRead;
          }
        } else {
          return ReadState.NotShow;
        }
      }
      return ReadState.Unread;
    });
    var readStatusText = computed(() => {
      var {
        readCount = 0
      } = props.message.readReceiptInfo;
      switch (readState.value) {
        case ReadState.Read:
          return TUITranslateService.t('TUIChat.已读');
        case ReadState.Unread:
          return TUITranslateService.t('TUIChat.未读');
        case ReadState.AllRead:
          return TUITranslateService.t('TUIChat.全部已读');
        case ReadState.PartiallyRead:
          return "".concat(readCount).concat(TUITranslateService.t('TUIChat.人已读'));
        default:
          return '';
      }
    });
    var isUseUnreadStyle = computed(() => {
      var {
        conversationType
      } = props.message;
      if (conversationType === 'C2C') {
        return readState.value !== ReadState.Read;
      } else if (conversationType === 'GROUP') {
        return readState.value !== ReadState.AllRead;
      }
      return false;
    });
    var isHoverFingerPointer = computed(() => {
      return props.message.needReadReceipt && props.message.conversationType === 'GROUP' && (readState.value === ReadState.PartiallyRead || readState.value === ReadState.Unread);
    });
    function openReadUserPanel() {
      if (isHoverFingerPointer.value) {
        emits('openReadUserPanel');
      }
    }
    function onDisplayMessageReadReceiptUpdate(isDisplay) {
      isDisplayMessageReadReceipt.value = isDisplay;
    }
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
          'message-label': true,
          'unread': _unref(isUseUnreadStyle),
          'finger-point': _unref(isHoverFingerPointer)
        }),
        onClick: openReadUserPanel
      }, [_createElementVNode("span", null, _toDisplayString(_unref(readStatusText)), 1)], 2)), [[_vShow, _unref(isShowReadStatus)]]);
    };
  }
});